import { Button, Grid, Typography } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";

import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { useGridDefinitions } from "../../../../../controls/ag-grid/components/GridDefinitions";
import { CatalogResultSource } from "../../../models/CatalogResultSource";
import { useGridStyles } from "../../../styles/gridStyles";
import { CreateResultSource } from "./CreateResultSource";
import { EditResultSource } from "./EditResultSource";
import { useTableData } from "./hooks";

type Props = {
	getCatalogResultSourcesFromAPI: Function;
	isLoading: boolean;
};

export const TableResultSource = ({
	getCatalogResultSourcesFromAPI,
	isLoading,
}: Props) => {
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [idResultSource, setIdResultSource] = useState<number | null>(null);
	const [quickFilterText, setQuickFilterText] = useState("");
	const { rows, columns, defaultColDef } = useTableData({});
	const { columnTypes } = useGridDefinitions({
		OnEdit: (data: CatalogResultSource) => {
			setShowEditModal(!showEditModal);
			setIdResultSource(data.ResultSourceId);
		},
	});

	const classes = useGridStyles();
	return (
		<>
			<Grid item xs={12} container justifyContent="center" spacing={1}>
				<Grid item md={12} xs={12}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Result Sources
					</Typography>
				</Grid>

				<Grid
					item
					xs={12}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid item xs={12} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search result sources"
						/>
					</Grid>
					<Grid
						item
						md={12}
						xs={12}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columns}
								getRowId={(params) => params.data.ResultSourceId}
								columnTypes={columnTypes}
								suppressContextMenu
								onRowDoubleClicked={(params) => {
									setIdResultSource(params.data.ResultSourceId);
									setShowEditModal(true);
								}}
								rowSelection="single"
								quickFilterText={quickFilterText}
							/>
						</div>
					</Grid>

					<Grid item md={"auto"} xs={12} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW RESULT SOURCE
						</Button>
					</Grid>
				</Grid>
			</Grid>

			<CreateResultSource
				show={showCreateModal}
				onHide={() => setShowCreateModal(false)}
				refreshData={getCatalogResultSourcesFromAPI}
			/>
			<EditResultSource
				show={showEditModal}
				onHide={(updated: boolean) => {
					setShowEditModal(false);
					setIdResultSource(null);
					if (updated) getCatalogResultSourcesFromAPI();
				}}
				resultSourceId={idResultSource}
			/>
		</>
	);
};
